import React, { useState } from 'react';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';
import plantObligationStates from '../../../../../../constants/plantObligationStates';
import errorHandler from '../../../../../components/error/ErrorHandler';

export default function GGCLStateHistory(props) {
  const { state, obligationID } = props;
  const dispatch = useDispatch();
  const { moduleBridgeHex, filtersHex } = useParams();
  const customStates = useSelector((s) => s.auth?.customStates);
  const poLevel3 = useSelector(
    (s) => s.currentPage?.obligationLevels?.level3?.[obligationID]
  );
  const [showHistory, setShowHistory] = useState(false);
  const [changes, setChanges] = useState(null);

  // > LOAD CHANGES
  const loadStateHistory = async () => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_globalLegalCompliance_evaluation_getStateHistory"
        ),
        { obligationID, filtersHex, moduleBridgeHex }
      );
      setChanges(response.data);
      setShowHistory(true);
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };
  // < LOAD CHANGES
  return (
    <>
      <AppRemixIcon
        onClick={() => loadStateHistory()}
        icon="calendar-check"
        title={ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="see.state.history" />
        )}
        color={poLevel3?.stateHistory ? colors.primaryLight : colors.grey300}
        filled={state}
        className="pointer"
      />
      <AppModal
        show={showHistory}
        onClose={() => setShowHistory(false)}
        title={ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="state.history" />
        )}
        size="xl"
      >
        <Scrollbars style={{ height: '380px' }}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="col-lg-6">
                  <Translator file="module-intelligence" name="plant" />
                </th>
                <th className="col-lg-2">
                  <Translator file="module-legalCompliance" name="date" />
                </th>
                <th className="col-lg-2">
                  <Translator file="user" name="user.state" />
                </th>
                <th className="col-lg-2">
                  <Translator file="general" name="general.user" />
                </th>
              </tr>
            </thead>
            <tbody>
              {changes &&
                changes.map((c) => (
                  <tr key={c.id}>
                    <td>{c.plant}</td>
                    <td>{c.dateStamp}</td>
                    <td>
                      {c.state !== 6 ? (
                        <b
                          className="p-1"
                          style={{
                            background: plantObligationStates[c.state].bgColor,
                            color: plantObligationStates[c.state].iconColor,
                            borderRadius: '2px',
                          }}
                        >
                          <Translator
                            file="user"
                            name={`user.obligations.state${
                              plantObligationStates[c.state].id
                            }`}
                          />
                        </b>
                      ) : (
                        <>
                          {customStates[c.customState] ? (
                            <b
                              className="p-1"
                              style={{
                                background: customStates[c.customState].bgColor,
                                color: customStates[c.customState].fgColor,
                                borderRadius: '2px',
                              }}
                            >
                              {customStates[c.customState].name}
                            </b>
                          ) : (
                            <span>A</span>
                          )}
                        </>
                      )}
                    </td>
                    <td>{c.user}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Scrollbars>
      </AppModal>
    </>
  );
}
